// extracted by mini-css-extract-plugin
export default {"root":"ChooseProject_root__CDBgX","card":"ChooseProject_card__yARho","img":"ChooseProject_img__wpRq5","text":"ChooseProject_text__WFha2"};